export const systemThemeName = [
  'light',
  'dark',
  'darkBlue',
  'jetBlack',
  'jetBlackSpooky',
  'halloween',
  'mint',
  'strawberry',
  'grape',
  'spring',
  'summer',
  'fall',
  'winter',
  'botanicalDay',
  'botanicalNight'
] as const
export type ValidSystemTheme = (typeof systemThemeName)[number]
